module.exports = __webpack_public_path__ + "img/download.111a023d.svg";